import { Action } from '../../definitions/types';
import {
  SET_AFFILIATE_ID,
  SET_TRIAL_TYPE,
  SET_EASY_MARKETING_TRACKING_ID,
} from '../actions/actions-consts';

export interface Affiliate {
  ref: string;
  trial: string;
  easyMarketingTrackId: string;
}

const initialState = {
  ref: '',
  trial: '',
  easyMarketingTrackId: '',
};

export const getTrsTrackId = (state: Affiliate): string => {
  if (!state) {
    return null;
  }
  return state.easyMarketingTrackId;
};

export default function affiliate(
  state: Affiliate = initialState,
  action: Action<string>
): Affiliate {
  switch (action.type) {
    case SET_AFFILIATE_ID:
      return {
        ...state,
        ...{ ref: action.payload },
      };
    case SET_TRIAL_TYPE:
      return {
        ...state,
        ...{ trial: action.payload },
      };
    case SET_EASY_MARKETING_TRACKING_ID:
      return {
        ...state,
        ...{ easyMarketingTrackId: action.payload },
      };
    default:
      return state;
  }
}
